import { combineReducers } from 'redux';
import { OutputReportReducer } from '../../actions/OutputReportActions';
import SurveyProjectsSlice from '../../survey/slices/SurveyProjectsSlice';
import SurveyProjectSlice from '../../survey/slices/SurveyProjectSlice';
import SurveyLoadingSlice from '../../survey/slices/SurveyLoadingSlice';
import SurveyTimerSlice from '../../survey/slices/SurveyTimerSlice';
import PerfeedSlice from '../../survey/slices/PerfeedSlice';

export default combineReducers({
    projects: SurveyProjectsSlice.reducer,
    project: SurveyProjectSlice.reducer,
    questionnaire: combineReducers({ timer: SurveyTimerSlice.reducer }),
    loading: SurveyLoadingSlice.reducer,
    perfeed: PerfeedSlice.reducer,
    report: OutputReportReducer,
});
